module.exports = __webpack_public_path__ + "img/c45ce09.jpg";